import { useImageUploader } from "../../../components/molecules/image-uploader/logic";
import { useNavigate } from "react-router-dom";

export const useUploadLogoPage = () => {
  const uploaderProps = useImageUploader();
  const navigate = useNavigate();

  const onContinue = () => {
    //navigate("/dashboard/home");
    location.replace("/dashboard/home");
  };

  return {
    ...uploaderProps,
    onContinue,
  };
}; 